module.exports = __webpack_public_path__ + "static/media/trash-can-grey.dd8ef36d.svg";